import React, { useState, useEffect } from 'react';
import { Snackbar, Button } from '@mui/material';

const UpdatePrompt = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    const handleUpdate = (event) => {
      setWaitingWorker(event.detail.registration.waiting);
      setShowUpdate(true);
    };
    window.addEventListener('serviceWorkerUpdate', handleUpdate);
    return () => window.removeEventListener('serviceWorkerUpdate', handleUpdate);
  }, []);

  const handleRefresh = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    }
  };

  return (
    <Snackbar
      open={showUpdate}
      message="A new version is available"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      action={
        <Button color="secondary" size="small" onClick={handleRefresh}>
          UPDATE
        </Button>
      }
    />
  );
};

export default UpdatePrompt;
